import enrollCmd from "../base/enrollCmd";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager.
 * nitgen plugin has no extra params 
 */
export const enrollNitgenMsg = () => {
    return "{'enrollType':'" + enrollCmd.CMD_NITGEN + "'}";
};

/**
  * converts the message to object type.
  * @param {*} obj
  */
export const decodeNitgenPluginMsg = (obj) => {
    // TODO
};